import React, { useEffect, useState } from 'react';
import { TitlePreset } from '@lux/title';
import { Preset, Text } from '@lux/text';
import { Translate, TranslateScope } from '@pegasus/translation';
import {
    Category,
    CategoryList,
    fetchFilterForCrossCampaignCategory,
    setCrossCampaignIdFromSessionStorage,
} from '@browsing/filters';
import debounce from 'lodash/debounce';

import { track } from '@client/helpers/tracking';
import { getSelectedCategories, getTrackingCategoryFilterValues } from './helpers';
import * as S from './cross-campaign-entry.styles';

const categoryToImageMapping = {
    1: 'https://img01.ztat.net/zl-campaignC/cross_campaign/Woman.jpg',
    2: 'https://img01.ztat.net/zl-campaignC/cross_campaign/Men.jpg',
    3: 'https://img01.ztat.net/zl-campaignC/cross_campaign/Girl.jpg',
    4: 'https://img01.ztat.net/zl-campaignC/cross_campaign/Boy.jpg',
    5: 'https://img01.ztat.net/zl-campaignC/cross_campaign/Home.jpg',
};

export const CrossCampaignEntry = () => {
    const [allCategories, setAllCategories] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState(null);

    useEffect(() => {
        const fetchFilterCategories = async () => {
            try {
                const categories = await fetchFilterForCrossCampaignCategory();
                setAllCategories(categories.category_filter);
                track('crossCampaignFilter_lvl1_shown');
            } catch (e) {
                console.log(e);
            }
        };
        fetchFilterCategories();
    }, []);

    const updateFilter = (filter: any) => {
        const categoryId = filter.categories[0];
        const selected = getSelectedCategories(categoryId, allCategories);
        setSelectedCategories(selected);
    };

    const setVisibilityFilter = (_: string, isWithoutHashMeta: boolean, shouldSave?: boolean) => {
        if (shouldSave === true) {
            const filterValues = getTrackingCategoryFilterValues(
                selectedCategories.parentId,
                allCategories,
                [selectedCategories.id],
            );

            track(`crossCampaignFilter_lvl${filterValues.length}_apply`, {
                filterValues: filterValues.join(';'),
            });

            setCrossCampaignIdFromSessionStorage(selectedCategories.id);
            window.location.href = '/articles';
        } else {
            setSelectedCategories(null);
        }
    };

    if (!allCategories) {
        return null;
    }

    const handleClick = (category: any) => {
        setSelectedCategories(category);
        track('crossCampaignFilter_lvl1_click', {
            filterValues: category.id,
        });
        track('crossCampaignFilter_lvl2_shown');
    };

    const handleScroll = debounce(() => {
        track('crossCampaignFilter_lvl1_swipe');
    }, 100);

    const onToggleSelection = (depth: number, isExpanded: boolean) => {
        if (depth === 2) {
            if (isExpanded) {
                track('crossCampaignFilter_lvl2_shown');
            } else {
                track('crossCampaignFilter_lvl3_shown');
            }
        }
    };

    return (
        <S.CrossCampaignContainer>
            <TranslateScope path="catalog">
                {selectedCategories && (
                    <CategoryList
                        allCategories={allCategories}
                        availableCategories={allCategories}
                        selectedCategories={[selectedCategories.id]}
                        campaign={null}
                        setVisibilityFilter={setVisibilityFilter}
                        showCategoriesModal={true}
                        updateFilter={updateFilter}
                        totalArticlesCount={selectedCategories.count}
                        isResetHidden={true}
                        disableRootCategoryToggle={true}
                        isCrossCampaign={true}
                        onToggleSelection={onToggleSelection}
                        isMyLoungeCrossCampaign={true}
                    />
                )}
            </TranslateScope>
            <S.StyledTitle preset={TitlePreset.XS}>
                <Translate message="crossCampaign.entryPoint.title" />
            </S.StyledTitle>
            <S.Container onScroll={handleScroll}>
                {allCategories.categories.map(
                    (category: Category) =>
                        categoryToImageMapping[category.sortId] && (
                            <S.Wrapper key={category.sortId}>
                                <S.StyledImageWrapper onClick={() => handleClick(category)}>
                                    <S.StyledImage
                                        src={categoryToImageMapping[category.sortId]}
                                        alt={category.name}
                                    />
                                </S.StyledImageWrapper>
                                <Text preset={Preset.XS}>{category.name}</Text>
                            </S.Wrapper>
                        ),
                )}
            </S.Container>
        </S.CrossCampaignContainer>
    );
};
